const PayOptions = {
    PAY_BY_CARD: 'card',
    PAY_MANUALLY: 'manually',
};

export default PayOptions;